import api from "@/components/customAxios/Axios";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useState } from "react";

import Modal from "react-modal";

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		zIndex: 1000,
		borderRadius: "10px",

		width: "100%", // Adjust modal width for responsiveness
		maxWidth: "600px", // Max width for larger screens
		maxHeight: "90vh", // Limit height for smaller screens
	},
};

const AddTeamUser = ({
	setAddNewUser,
}: {
	setAddNewUser: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
	const [modalIsOpen, setIsOpen] = useState(false);
	const { setLoading } = useLoader();
	const toast = useToast();
	const [email, setEmail] = useState<string>("");
	const [dashboardAccess, setDashboardAccess] = useState<boolean>(false);
	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}
	const addMember = async (e: any) => {
		e.preventDefault();
		setLoading(true);
		try {
			console.log(dashboardAccess, email);
			const res = await api.post(`/add_company_user`, {
				email: email,
				user_type: dashboardAccess ? "Admin" : "User",
			});
			if (res.status === 201) {
				toast.success({
					type: "background",
					duration: 3000,
					status: "Success",
					title: "User Added Successfully",
					description: "User has been added successfully.",
					open: true,
				});
				setEmail("");
				setDashboardAccess(false);
				setAddNewUser((prev) => !prev);
				closeModal();
			}
			// setCandidateDetails(res.data);
		} catch (err: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error adding a user",
				description: err.response?.data?.error || err.response?.data?.message || "An error occurred.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<button
				onClick={openModal}
				className=" px-2 py-1 rounded-md hover:scale-110 transition duration-300 ease-in-out flex items-center justify-center gap-1.5"
			>
				<svg
					width="18"
					height="18"
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1 9H17"
						stroke="black"
						strokeWidth="1.5"
						strokeLinecap="round"
					/>
					<path
						d="M9 17L9 1"
						stroke="black"
						strokeWidth="1.5"
						strokeLinecap="round"
					/>
				</svg>
			</button>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Candidate Information Modal"
			>
				<h3 className="text-lg">Add Team Member</h3>
				<form>
					<div className=" mt-5 ">
						<div className="flex-1  items-center gap-2">
							<label className="block text-sm font-medium text-gray-400 mb-2">
								User Email
							</label>
							<input
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								name="Enter Your User Email"
								type="email"
								required
								placeholder="User Email"
								className="w-full border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
							/>
						</div>

						<div className="mt-3 space-x-2 flex items-center">
							<input
								// value={dashboardAccess}
								onChange={(e) => setDashboardAccess(e.target.checked)}
								name="Give Admin Access"
								type="checkbox"
								className=" border rounded-lg py-2 px-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
							/>
							<label className=" text-sm font-medium text-gray-400 ">
								Give Admin Access
							</label>
						</div>
					</div>
					<div className="mt-6 flex justify-end space-x-3">
						<button
							className="bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded hover:scale-110 transition"
							onClick={addMember}
						>
							Add
						</button>
						<button
							onClick={closeModal}
							className="px-4 py-2 text-[#438437] border-1 rounded-md hover:scale-110 transition"
						>
							Cancel
						</button>
					</div>
				</form>
			</Modal>
		</div>
	);
};

export default AddTeamUser;
